import './PracticesListFiltered.scss'

import { useContext, useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'

import { isFreePracticeCategory } from 'components/common/api/Practices'
import SubscriptionContext from 'components/common/contexts/SubscriptionContext'
import {
  EVENT_ACTION_PAGEVIEW,
  EVENT_CATEGORY_PRACTICES,
  saveUserEvent
} from 'components/common/api/UserEvents'
import PracticeCard from '../PracticeCard'

/**
 * Practices List Filtered component. Used to display categories of practice categories with filters
 * @param {Object} param0 Initial props
 */
export default function PracticesListFiltered({
  categories,
  practiceType,
  baseUrl,
  lockedReturnPath
}) {
  const { userSubscription: subscription, userHasPremiumAccess } =
    useContext(SubscriptionContext)
  const [isLocked, setIsLocked] = useState(true)

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Return early if we don't have type or subscription data
    if (!practiceType || !subscription) return

    // Does the user have a valid subscription?
    setIsLocked(!userHasPremiumAccess)

    // Log access
    saveUserEvent(
      EVENT_CATEGORY_PRACTICES,
      EVENT_ACTION_PAGEVIEW,
      `${practiceType} list`
    )
  }, [practiceType, subscription, userHasPremiumAccess])

  return !categories?.length ? null : (
    <Row xs={1} sm={2} xl={3} className='practices-list filtered'>
      {categories.map((category, index) =>
        // Does the category have children? Show them. Otherwise, use the category itself
        category.children?.length ? (
          <div key={category.term_id}>
            <h3 className='title mt-4 mb-2 w-100'>{category.name}</h3>
            {category.children.map((item, i) => (
              <Col key={item.term_id}>
                <PracticeCard
                  title={item.name}
                  practiceId={item.term_id}
                  baseUrl={baseUrl}
                  style={{ animationDelay: `${0.05 * i}s` }}
                  // Check to see if the current practice is free
                  isLocked={
                    isLocked &&
                    !isFreePracticeCategory(practiceType, item.term_id)
                  }
                  lockedReturnPath={lockedReturnPath}
                  practiceType={practiceType}
                />
              </Col>
            ))}
          </div>
        ) : (
          <Col key={category.term_id}>
            <PracticeCard
              title={category.name}
              practiceId={category.term_id}
              baseUrl={baseUrl}
              style={{ animationDelay: `${0.05 * index}s` }}
              // Check to see if the current practice is free
              isLocked={
                isLocked &&
                !isFreePracticeCategory(practiceType, category.term_id)
              }
              lockedReturnPath={lockedReturnPath}
              practiceType={practiceType}
            />
          </Col>
        )
      )}
    </Row>
  )
}
